import { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { ModelWindow } from "../../Components/ModelWindow/ModelWindow";
import {
  AddButtonTask,
  ButtonDownload,
  ButtonNotificationToggleCard,
  ButtonSearch,
  ContainerButtons,
  ContainerDateTask,
  ContainerDateTimeTask,
  ContainerDisplayData,
  ContainerFeaturesTask,
  ContainerInfoTask,
  ContainerTask,
  ContainerTasksUser,
  ContainerTimeTask,
  DataTask,
  DataTaskTitle,
  DeleteButton,
  DescriptionTask,
  EditButton,
  ListTaskCard,
  ListTasks,
  NameTask,
  SearchTask,
  SearchTaskInput,
  TimeTask,
  TimeTaskTitle,
} from "../Components/HomePage/Tasks/TasksStyles.styled";
import { useAppDispatch, useAppSelector } from "../../Redux/store";
import { Task } from "../../Redux/tasks/slice";
import useAuth from "../../Redux/useAuth";
import { getAllTasks } from "../../Redux/tasks/operators";
import { selectAllTasks } from "../../Redux/tasks/selectors";
import { DeleteTaskModels } from "../Components/HomePage/Tasks/ModelWindows/DeleteModel/DeleteTaskModel";
import { AddTaskModel } from "../Components/HomePage/Tasks/ModelWindows/AddTaskModel/AddTaskModel";
import { EditTaskModel } from "../Components/HomePage/Tasks/ModelWindows/EditingModel/EditTaskModel";
import {
  AddIcon,
  DeleteIcon,
  DownloadIcon,
  EditIcon,
  NotificationOffIconTask,
  NotificationOnIconTask,
  SearchIcon,
} from "../Components/HomePage/Tasks/Icons/icons";
import { downloadPDF } from "../Components/HomePage/Tasks/PDFDocument/donwloadPDF";
import {
  ContainerNewTask,
  MessageNotAdd,
  MessageNotFound,
  NoFoundTaskContainer,
  NotAddedTaskContainer,
} from "../Components/HomePage/HomePageStyles.styled";
import { TaskNotification } from "../Components/HomePage/Tasks/TaskNotification";
import { useLanguageContext } from "../../Components/Languages/Langs/LanguageContext";
// add notification system with styles []

export const Tasks = () => {
  const dispatch = useAppDispatch();
  const { user } = useAuth();
  const { t } = useLanguageContext();
  const tasks = useAppSelector(selectAllTasks);
  const [selectedTask, setSelectedTask] = useState<Task | null>(null);

  const [searchQuery, setSearchQuery] = useState<string>("");
  const [allTasks, setAllTasks] = useState<Task[]>([]);
  const [filteredTasks, setFilteredTasks] = useState<Task[]>([]);
  const [notificationsIcons, setNotificationsIcons] = useState<{
    [key: string]: boolean;
  }>({});

  const notificationSetting = (taskId: string) => {
    setNotificationsIcons((prev) => {
      const newState = { ...prev, [taskId]: !prev[taskId] };
      localStorage.setItem("notifications-icons", JSON.stringify(newState));
      return newState;
    });
  };

  const dataTasksForm = async (evt: React.FormEvent<HTMLFormElement>) => {
    evt.preventDefault();
    try {
      const resultAction = await dispatch(getAllTasks()).unwrap();
      setAllTasks(resultAction);
      setFilteredTasks(resultAction);
    } catch (error) {
      console.log(error);
    }
  };

  const validationSearch = (): boolean => {
    const searchBar = !searchQuery.trim();

    if (searchBar) {
      toast.warning("search is required");
      return false;
    }

    return true;
  };

  const searchTasks = (evt: React.ChangeEvent<HTMLInputElement>) => {
    const query = evt.target.value;
    setSearchQuery(query);

    const filtered = allTasks.filter((task) =>
      task.name.toLowerCase().includes(query)
    );

    setFilteredTasks(filtered);
  };

  // Sync notifications with existing tasks
  useEffect(() => {
    const saved = localStorage.getItem("notifications-icons");
    let savedIcons: { [key: string]: boolean } = saved ? JSON.parse(saved) : {};

    tasks.forEach((task) => {
      const id = task._id ?? task.id;
      if (!(id in savedIcons)) savedIcons[id] = false;
    });

    setNotificationsIcons(savedIcons);
  }, [tasks]);

  useEffect(() => {
    const fetchTasks = async () => {
      try {
        const resultAction = await dispatch(getAllTasks()).unwrap();
        setAllTasks(resultAction);
        setFilteredTasks(resultAction);
      } catch (error) {
        console.log(error);
      }
    };

    fetchTasks();
  }, [dispatch]);

  // Model window

  const [showModel, setShowModel] = useState<boolean>(false);
  const [isOpenModel, setIsOpenModel] = useState<boolean>(false);

  const [showModelAdd, setShowModelAdd] = useState<boolean>(false);
  const [isOpenModelAdd, setIsOpenModelAdd] = useState<boolean>(false);

  const [showModelEdit, setShowModelEdit] = useState<boolean>(false);
  const [isOpenModelEdit, setIsOpenModelEdit] = useState<boolean>(false);

  const openModelDelete = (task: Task) => {
    setSelectedTask(task);
    setShowModel(true);
    setTimeout(() => setIsOpenModel(true), 0);
  };

  const closeModelDelete = () => {
    setIsOpenModel(false);
    setTimeout(() => setShowModel(false), 250);
  };

  const openAddModel = () => {
    setShowModelAdd(true);
    setTimeout(() => setIsOpenModelAdd(true), 0);
  };

  const closeAddModel = () => {
    setIsOpenModelAdd(false);
    setTimeout(() => setShowModelAdd(false), 250);
  };

  const openEditModel = (task: Task) => {
    setSelectedTask(task);
    setShowModelEdit(true);
    setTimeout(() => setIsOpenModelEdit(true), 0);
  };

  const closeEditModel = () => {
    setIsOpenModelEdit(false);
    setTimeout(() => setShowModelEdit(false), 250);
  };

  // notification

  const [notificationButton, setNotificationButton] = useState<boolean>(false);

  const notificationToggle = () => {
    const newValue = !notificationButton;
    setNotificationButton(newValue);
    localStorage.setItem("notification-setting", JSON.stringify(newValue));

    // ОНОВЛЮЄМО ВСІ ІКОПКИ У TASK CARD
    const updatedIcons: { [key: string]: boolean } = {};
    allTasks.forEach((task) => {
      const taskId = task._id ?? task.id;
      updatedIcons[taskId] = newValue;
    });
    setNotificationsIcons(updatedIcons);
    localStorage.setItem("notifications-icons", JSON.stringify(updatedIcons));
  };

  useEffect(() => {
    const settingNotification = localStorage.getItem("notification-setting");
    if (settingNotification) {
      setNotificationButton(JSON.parse(settingNotification));
    }
  }, []);

  useEffect(() => {
    localStorage.setItem(
      "notifications-icons",
      JSON.stringify(notificationsIcons)
    );
  }, [notificationsIcons]);

  useEffect(() => {
    setFilteredTasks(tasks);
    getAllTasks();
  }, [tasks]);

  return (
    <>
      <ContainerNewTask>
        <TaskNotification
          buttonToggle={notificationButton}
          swicherIcon={notificationToggle}
        />
        <AddButtonTask type="button" onClick={openAddModel}>
          <AddIcon />
        </AddButtonTask>
        <SearchTask onSubmit={dataTasksForm}>
          <SearchTaskInput
            type="text"
            name="search"
            value={searchQuery}
            placeholder={t("privateTraslate.taskUser.searchInput")}
            onChange={searchTasks}
          />
          <ButtonSearch type="button" onClick={() => validationSearch()}>
            <SearchIcon />
          </ButtonSearch>
        </SearchTask>
      </ContainerNewTask>
      {filteredTasks.length === 0 ? (
        searchQuery ? (
          <NoFoundTaskContainer>
            <MessageNotFound>
              {t("privateTraslate.taskUser.noFoundTask")}
            </MessageNotFound>
          </NoFoundTaskContainer>
        ) : (
          <NotAddedTaskContainer>
            <MessageNotAdd>
              {t("privateTraslate.taskUser.noAddedTask")}
            </MessageNotAdd>
          </NotAddedTaskContainer>
        )
      ) : (
        <ContainerTasksUser>
          <ListTasks>
            {filteredTasks.map((task) => {
              const taskId = task._id;

              return (
                <ListTaskCard key={taskId}>
                  <ContainerTask>
                    <ContainerInfoTask>
                      <NameTask>{task.name}</NameTask>
                      <DescriptionTask>{task.description}</DescriptionTask>
                    </ContainerInfoTask>

                    <ContainerButtons>
                      <EditButton
                        type="button"
                        onClick={() => openEditModel(task)}
                      >
                        <EditIcon />
                      </EditButton>
                      <DeleteButton
                        type="button"
                        onClick={() => openModelDelete(task)}
                      >
                        <DeleteIcon />
                      </DeleteButton>
                    </ContainerButtons>

                    <ContainerDateTimeTask>
                      <ContainerDisplayData>
                        <ContainerDateTask>
                          <DataTaskTitle>
                            {t("privateTraslate.taskUser.dataTask")}
                          </DataTaskTitle>
                          <DataTask>{task.date}</DataTask>
                        </ContainerDateTask>
                        <ContainerTimeTask>
                          <TimeTaskTitle>
                            {t("privateTraslate.taskUser.timeTask")}
                          </TimeTaskTitle>
                          <TimeTask>{task.time}</TimeTask>
                        </ContainerTimeTask>
                      </ContainerDisplayData>
                      <ContainerFeaturesTask>
                        <ButtonDownload
                          type="button"
                          onClick={() =>
                            downloadPDF(user?.name ?? "Unknown", [task], t)
                          }
                        >
                          <DownloadIcon />
                        </ButtonDownload>

                        {notificationsIcons[taskId] ? (
                          <ButtonNotificationToggleCard
                            type="button"
                            onClick={() => notificationSetting(taskId)}
                          >
                            <NotificationOnIconTask />
                          </ButtonNotificationToggleCard>
                        ) : (
                          <ButtonNotificationToggleCard
                            type="button"
                            onClick={() => notificationSetting(taskId)}
                          >
                            <NotificationOffIconTask />
                          </ButtonNotificationToggleCard>
                        )}
                      </ContainerFeaturesTask>
                    </ContainerDateTimeTask>
                  </ContainerTask>
                </ListTaskCard>
              );
            })}
          </ListTasks>
        </ContainerTasksUser>
      )}
      {showModel && selectedTask && (
        <ModelWindow onClose={closeModelDelete} isOpen={isOpenModel}>
          <DeleteTaskModels
            task={selectedTask}
            deleteTaskById={setFilteredTasks}
            onClose={closeModelDelete}
          />
        </ModelWindow>
      )}
      {isOpenModelAdd && (
        <ModelWindow onClose={closeAddModel} isOpen={showModelAdd}>
          <AddTaskModel onClose={closeAddModel} />
        </ModelWindow>
      )}

      {isOpenModelEdit && selectedTask && (
        <ModelWindow onClose={closeEditModel} isOpen={showModelEdit}>
          <EditTaskModel onClose={closeEditModel} task={selectedTask} />
        </ModelWindow>
      )}
    </>
  );
};
